// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__cPLMQ","title":"card_title__6n7ds","subtitle":"card_subtitle__vE_GE","close":"card_close__z8mhG","textButton":"card_textButton__G6xRZ","body":"card_body__X2m8Y"};